import { Injectable } from '@angular/core';

@Injectable()
export class CalendarHandlerProvider {
	date: any;
	schedule: any;
	availableIntervals: any = [];
	selectedInterval: any;

	bookedHours: any = [];

	constructor() {}

	setupIntervals(date){
		this.date = date;

		this.selectedInterval = null;

	    var day = this.date.format("dddd");

	    var schedule = this.schedule.schedule.find(
	      (sched)=>{
	        return sched.day == day;
	      }
	    );

	    if(schedule){
	    	var selectedDate = this.addDaysToDate(this.date.toDate(), 1);

	    	if(this.intervalsPossible(schedule.to) || !this.isToday(selectedDate)){
		    	var from = schedule.from;
		    
		    	if(this.isToday(selectedDate)){
		    		from = this.setFrom(schedule.from);	
		    	}	    

				this.availableIntervals = this.makeTimeIntervals(
					from, 
					schedule.to, 
					this.schedule.config.interval
				);
	    	}else{
	    		this.availableIntervals = [];
	    	}
	    }else{
	    	this.availableIntervals = [];
	    }
	}

	addDaysToDate(date, days){
		date.setDate(date.getDate() + days);

		return date;
	}

	isToday(date){
		const today = new Date()
		var isToday = 	date.getDate() == today.getDate() &&
						date.getMonth() == today.getMonth() &&
						date.getFullYear() == today.getFullYear();
		return 	isToday
	}

	setFrom(from){
		let now = this.makeTimeMilitary(new Date().toLocaleTimeString());
		var returnVal = from;

		let hourFrom = parseInt(from.split(":")[0]);
		let hourNow = parseInt(now.split(":")[0]);

		if( hourFrom <= hourNow ){
			returnVal = hourNow + ":00";
		}

		return returnVal;
	}

	intervalsPossible(to){
		var returnVal = true;
		let now = this.makeTimeMilitary(new Date().toLocaleTimeString());

		let hourTo = parseInt(to.split(":")[0]);
		let hourNow = parseInt(now.split(":")[0]);

		if(hourTo == hourNow || hourTo<hourNow){
			returnVal = false;
		}

		return returnVal;
	}	

	makeTimeMilitary(time){
		var hours = Number(time.match(/^(\d+)/)[1]);
		var minutes = Number(time.match(/:(\d+)/)[1]);
		var AMPM = time.match(/\s(.*)$/)[1];
		if(AMPM == "PM" && hours<12) hours = hours+12;
		if(AMPM == "AM" && hours==12) hours = hours-12;
		var sHours = hours.toString();
		var sMinutes = minutes.toString();
		if(hours<10) sHours = "0" + sHours;
		if(minutes<10) sMinutes = "0" + sMinutes;

		return sHours + ":" + sMinutes;
	}

	selectInterval(selectedInterval){
		this.selectedInterval = selectedInterval;

		this.availableIntervals.forEach( 
			(item, key) => {
				if(item.id == this.selectedInterval.id){
					item.isSelected = true;
				}else{
					item.isSelected = false;
				}
			}
		);		
	}

	makeTimeIntervals(startTime, endTime, increment) {
		startTime = startTime.toString().split(':');
		endTime = endTime.toString().split(':');
		increment = parseInt(increment, 10);

		var pad = function (n) { return (n < 10) ? '0' + n.toString() : n; },
		    startHr = parseInt(startTime[0], 10),
		    startMin = parseInt(startTime[1], 10),
		    endHr = parseInt(endTime[0], 10),
		    endMin = parseInt(endTime[1], 10),
		    currentHr = startHr,
		    currentMin = startMin,
		    previous = currentHr + ':' + pad(currentMin),
		    current = '',
		    r = [],
		    am = 'AM',
		    pm = 'PM';

		var currentHrDisplay = (currentHr>12) ? currentHr-12 : currentHr;
		var hour24;

		previous = currentHrDisplay + ':' + pad(currentMin),

		hour24 = previous;

		previous = previous + 
		           ' ' + 
		           ((currentHr<12) ? am : pm);

		r.push({
		    	id: 1,
		    	interval: previous,
		    	hour24: hour24,
		    	isSelected: false
		    });

		let counter = 2;

		do {
		    currentMin += increment;
		    if ((currentMin % 60) === 0 || currentMin > 60) {
		        currentMin = (currentMin === 60) ? 0 : currentMin - 60;
		        currentHr += 1;
		    }

		    hour24 = currentHr + ':' + pad(currentMin);

		    currentHrDisplay = (currentHr>12) ? currentHr-12 : currentHr;

		    current = currentHrDisplay + ':' + pad(currentMin) +
		              ' ' + 
		              ((currentHr<12) ? am : pm)
		              ;

          	if(!this.hourIsBooked(hour24)){
			    r.push({
			    	id: counter,
			    	interval: current,
			    	hour24: hour24,
			    	isSelected: false
			    });
          	}

		    previous = current;
		    counter++;
		} while (currentHr !== endHr);

		return r;
	};  	

	hourIsBooked(hour): Boolean{
		var found = false;

		this.bookedHours.find((item)=>{
			var bookedHour = item.ServiceDate.toString().split("T")[1];

			bookedHour = bookedHour.substr(0, bookedHour.lastIndexOf(":"));

			if(bookedHour==hour){
				found=true;
			}
		});

		return found;
	}

	clearIntervals(){
		this.availableIntervals = [];
	}
}



// WEBPACK FOOTER //
// ./src/providers/calendar-handler.ts